import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import {
	Card,
	Alert,
	Row,
	Col,
	CardTitle,
	CardHeader,
	FormGroup
} from "reactstrap";
import { Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton/CustomButton";
import { getBusinessNatureList } from "../../redux/actions/getBusinessNatureListAction";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getBusinessNatureMappingList } from "../../redux/actions/getBusinessNatureMappingListAction";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
// import { SettingsPowerRounded } from "@mui/icons-material";
import { deleteBusinessNatureMapping } from "../../redux/actions/deleteBusinessNatureMappingAction";
import { createBusinessNatureMapping } from "../../redux/actions/createBusinessNatureMappingAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import DeleteIcon from "@mui/icons-material/Delete";
import BackButton from "../../components/BackButton/BackButton";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminAddNewBusinessNature = () => {
	const [businessNature, setBusinessNature] = useState("");
	const [
		businessNatureMappingListResArray,
		setBusinessNatureMappingListResArray
	] = useState([]);
	const [businessNatureMappingListStatus, setBusinessNatureMappingListStatus] =
		useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [isLoading, setIsLoading] = useState("");
	// const [logoutvalue, setLogoutvalue] = useState(false)
	// const [deleteInfo, setDeleteInfo] = useState("")
	const [open, setOpen] = useState(false);
	const [deleteIntegrationStatus, setDeleteIntegrationStatus] = useState(false);
	const [deleteIntegrationArray, setDeleteIntegrationArray] = useState([]);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [walletOwnerName, setWalletOwnerName] = useState("");
	const [walletBusinessNature, setWalletBusinessNature] = useState("");

	const [walletOwnerNameS, setWalletOwnerNameS] = useState("");
	const [walletBusinessNatureS, setWalletBusinessNatureS] = useState("");
	const [addOpen, setAddOpen] = React.useState(false);


	const [
		createBusinessNatureMappingStatus,
		setCreateBusinessNatureMappingStatus
	] = useState(false);
	const [
		createBusinessNatureMappingResArray,
		setCreateBusinessNatureMappingResArray
	] = useState([]);

	const [mappingId, setMappingId] = useState("");

	const classes = useStyles();
	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getBusinessNature = useSelector(
		({ getBusinessNatureList }) => getBusinessNatureList
	);
	const getOwnerAndNameList = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);
	const BusinessNatureMappingList = useSelector(
		({ getBusinessNatureMappingList }) => getBusinessNatureMappingList
	);
	const CreateBusinessNatureMappingRes = useSelector(
		({ createBusinessNatureMapping }) => createBusinessNatureMapping
	);
	const deleteIntegrationRes = useSelector(
		({ deleteBusinessNatureMapping }) => deleteBusinessNatureMapping
	);

	console.log(deleteIntegrationRes, "deleteIntegrationRes");
	const BusinessNatureManagementRequest = () => {
		// setGetBusinessNatureListStatus(true);
		setIsLoading(true);
		const BusinessNatureManagementReq = {
			// adminId: 2,
			adminId: val.adminIDS,

			businessNature: businessNature || ""
		};
		dispatch(
			getBusinessNatureList(
				BusinessNatureManagementReq,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	const getWalletOwnerIdAndNameListRequest = () => {
		const getWalletOwnerIdAndNameListReq = {
			loginDetails: {
				// adminId: 2
				adminId: val.adminIDS

			}
		};
		dispatch(
			getWalletOwnerIdAndNameList(
				getWalletOwnerIdAndNameListReq,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	const getBusinessNatureMappingListRequest = () => {
		setBusinessNatureMappingListStatus(true);
		const getBusinessNatureMappingListReq = {
			// adminId: 2,
			adminId: val.adminIDS,

			walletOwnerId: walletOwnerNameS == "Select Owner ID" ? "" : walletOwnerNameS.split("-")[0],
			businessNature: walletBusinessNatureS == "Select Business Nature" ? "" : walletBusinessNatureS
		};
		dispatch(
			getBusinessNatureMappingList(
				getBusinessNatureMappingListReq,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	// const searchHandleAPI = () => {
	//   BusinessNatureManagementRequest()
	//   getWalletOwnerIdAndNameListRequest()
	//   getBusinessNatureMappingListRequest()

	//   console.log(BusinessNatureMappingList, 'BusinessNatureMappingList');
	// }

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			BusinessNatureManagementRequest();
			getWalletOwnerIdAndNameListRequest();
			getBusinessNatureMappingListRequest();
		}
	}, [regenerateTokenRes.data.status]);

	const MappingListRes = () => {
		if (BusinessNatureMappingList.data.status == "success") {
			setIsLoading(false);
			setBusinessNatureMappingListResArray(
				[].concat(BusinessNatureMappingList.data.roleList)
			);
		}
		if (BusinessNatureMappingList.data.status == "Failed") {
			setIsLoading(false);
			setBusinessNatureMappingListResArray(
				BusinessNatureMappingList.data.roleList
			);
			NotificationPopups(
				"error",
				"Failed",
				BusinessNatureMappingList.data.description ||
				BusinessNatureMappingList.description
			);
			if (
				BusinessNatureMappingList.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				BusinessNatureMappingList.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (BusinessNatureMappingList.data.status === "failed") {
			setIsLoading(false);
			setBusinessNatureMappingListResArray(
				BusinessNatureMappingList.data.roleList
			);
			NotificationPopups(
				"error",
				"Failed",
				BusinessNatureMappingList.data.description ||
				BusinessNatureMappingList.description
			);
			if (
				BusinessNatureMappingList.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				BusinessNatureMappingList.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			// setOpen(false);
			// setLogoutvalue(true);
		}
		if (BusinessNatureMappingList.data.status == "NOT FOUND") {
			setBusinessNatureMappingListResArray(BusinessNatureMappingList.data);
			setIsLoading(false);
			NotificationPopups(
				"error",
				"NOT FOUND",
				BusinessNatureMappingList.data.description ||
				BusinessNatureMappingList.description
			);
		}
	};

	useEffect(() => {
		if (businessNatureMappingListStatus) {
			MappingListRes();
		}
	}, [BusinessNatureMappingList.data.status]);

	useEffect(() => {
		if (BusinessNatureMappingList.data.status == "success") {
			setPage(0);
		}
	}, [BusinessNatureMappingList.data.status]);

	// useEffect(() => {
	//   getWalletOwnerIdAndNameListRequest()
	// }, [])

	// useEffect(() => {
	//   BusinessNatureManagementRequest()
	// }, [])

	console.log(getBusinessNature, "getBusinessNature");
	// Pagination
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const deleteIntegration = () => {
		setDeleteIntegrationStatus(true);
		setOpen(false);
		let req = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,

				mappingId: mappingId
			}
		};
		dispatch(deleteBusinessNatureMapping(req, authToken));
	};

	const deleteIntegrationResFunc = () => {
		if (deleteIntegrationStatus) {
			if (deleteIntegrationRes.data.status == "success") {
				setDeleteIntegrationArray(deleteIntegrationRes.data);
				setNotificationOpen(true);
				getBusinessNatureMappingListRequest();
			}
			if (deleteIntegrationRes.data.status == "failed") {
				setDeleteIntegrationArray(deleteIntegrationRes.data);
				setNotificationOpen(true);
				if (
					deleteIntegrationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteIntegrationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};
	useEffect(() => {
		deleteIntegrationResFunc();
	}, [deleteIntegrationRes.data.status]);

	const deleteIntegrationFunc = (row) => {
		setMappingId(row);
		setOpen(true);
	};

	const CreateBusinessNatureMappingReq = () => {
		setCreateBusinessNatureMappingStatus(true);
		setIsLoading(true);
		const req = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,
				
				ownerID: walletOwnerName.split("-")[0],
				businessNature: walletBusinessNature
			}
		};
		// console.log("reQQQ",req)
		dispatch(createBusinessNatureMapping(req, authToken));
	};

	const CreateBusinessNatureMappingFunc = () => {
		if (createBusinessNatureMappingStatus) {
			if (CreateBusinessNatureMappingRes.data.status == "success") {
				setIsLoading(false);
				setCreateBusinessNatureMappingResArray(
					CreateBusinessNatureMappingRes.data
				);
				setNotificationOpen(true);
				getBusinessNatureMappingListRequest();
			}
			if (CreateBusinessNatureMappingRes.data.status == "failed") {
				setIsLoading(false);
				setCreateBusinessNatureMappingResArray(
					CreateBusinessNatureMappingRes.data
				);
				setNotificationOpen(true);
				if (
					CreateBusinessNatureMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					CreateBusinessNatureMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (CreateBusinessNatureMappingRes.data.status == "INVALID REQUEST") {
				setIsLoading(false);
				setCreateBusinessNatureMappingResArray(
					CreateBusinessNatureMappingRes.data
				);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		CreateBusinessNatureMappingFunc();
	}, [CreateBusinessNatureMappingRes.data.status]);

	const handleClose = () => {
		setOpen(false);
		setMappingId("");
		setAddOpen(false);

	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "WalletOwnerID") {
			setWalletOwnerName(value);
		}
		if (name === "BusinessNature") {
			setWalletBusinessNature(value);
		}
		if (name === "WalletOwnerIDS") {
			setWalletOwnerNameS(value);
		}
		if (name === "BusinessNatureS") {
			setWalletBusinessNatureS(value);
		}
	};

	const handleNoticationClose = () => {
		setCreateBusinessNatureMappingResArray([]);
		setDeleteIntegrationArray([]);
		setWalletOwnerName("Select Owner ID");
		setWalletBusinessNature("Select Business Nature");
		setBusinessNature("Select Business Nature");
		setNotificationOpen(false);
	};

	const addRole = () => {
		// setWalletOwnerId('')
		setWalletOwnerName('')
		setWalletBusinessNature('')
		setAddOpen(true);
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid
						container
						style={{ padding: "25px", justifyContent: "right" }}
						spacing={2}
					>
						<Grid item md={2} sm={12} xs={12} lg={2}>


							<CustomButton
								style={{
									padding: "8px",
									width: "80px"
								}}
								onClick={() => addRole()}

							>
								Create
							</CustomButton>

						</Grid>

					</Grid>

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								// required
								select
								autoFocus
								margin="dense"
								id="name"
								label="Owner ID"
								type="name"
								fullWidth
								variant="standard"
								name="WalletOwnerIDS"
								// value={role || ""}
								// defaultValue={"All" || role}
								onChange={handleChange}
								value={walletOwnerNameS || "Select Owner ID"}
							>
								<MenuItem value="Select Owner ID" selected="SelectAll">
									Select Owner ID
								</MenuItem>
								{getOwnerAndNameList.success &&
									getOwnerAndNameList.data.ownerList.map((dropdown) => (
										<MenuItem value={dropdown}>{dropdown}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								// required
								select
								autoFocus
								margin="dense"
								id="name"
								label="Business Nature"
								type="text"
								fullWidth
								variant="standard"
								name="BusinessNatureS"
								value={walletBusinessNatureS || "Select Business Nature"}
								// style={{ fontWeight: 'bold', color: 'white' }}
								// defaultValue={"All" || role}
								onChange={handleChange}
							>
								<MenuItem value="Select Business Nature" selected="SelectAll">
									Select Business Nature
								</MenuItem>
								{getBusinessNature.success &&
									getBusinessNature.data.roleList &&
									[]
										.concat(getBusinessNature.data.roleList)
										.map((dropdown) => (
											<MenuItem value={dropdown.role}>{dropdown.role}</MenuItem>
										))}
								{/* {getBusinessNature.success &&
                  getBusinessNature.data.roleList.map((dropdown) => (
                    <MenuItem value={dropdown.role}>{dropdown.role}</MenuItem>))} */}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<CustomButton
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								className="riskRuleButton"
								// onClick={CreateBusinessNatureMappingReq}
								onClick={getBusinessNatureMappingListRequest}
							>
								Search
							</CustomButton>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
                onClick={GetCustomerListRequest}
              >
                Search
              </Button> */}
							{/* <CustomButton
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
                onClick={searchHandleAPI}
              >
                Search
              </CustomButton> */}
						</Grid>
					</Grid>
				</Card>

				{/*  */}

				{/* <Card> */}
				{isLoading ? (
					<LoadingSpinner />
				) : businessNatureMappingListResArray.length == undefined ||
					businessNatureMappingListStatus == false ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									style={{ padding: "6px 20px 6px 16px !important" }}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mapping ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Owner Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Business Nature
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Creation Date
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{businessNatureMappingListResArray &&
											[]
												.concat(businessNatureMappingListResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														<TableCell align="center">
															{row.operationId}
														</TableCell>
														<TableCell align="center">
															{row.walletOwnerName}
														</TableCell>
														<TableCell align="center">
															{row.businessNature}
														</TableCell>
														<TableCell align="center">
															{row.creationTime}
														</TableCell>
														<TableCell align="center">
															<Tooltip title="Delete">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		deleteIntegrationFunc(row.operationId)
																	}
																>
																	{
																		<DeleteIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={businessNatureMappingListResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>Create Mapping</DialogTitle>
						<DialogContent>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									required
									select
									autoFocus
									margin="dense"
									id="name"
									label="Owner ID"
									type="name"
									fullWidth
									variant="standard"
									name="WalletOwnerID"
									// value={role || ""}
									// defaultValue={"All" || role}
									onChange={handleChange}
									value={walletOwnerName || "Select Owner ID"}
								>
									<MenuItem value="Select Owner ID" selected="SelectAll">
										Select Owner ID
									</MenuItem>
									{getOwnerAndNameList.success &&
										getOwnerAndNameList.data.ownerList.map((dropdown) => (
											<MenuItem value={dropdown}>{dropdown}</MenuItem>
										))}
								</TextField>
							</Grid>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									required
									select
									autoFocus
									margin="dense"
									id="name"
									label="Business Nature"
									type="text"
									fullWidth
									variant="standard"
									name="BusinessNature"
									value={walletBusinessNature || "Select Business Nature"}
									// style={{ fontWeight: 'bold', color: 'white' }}
									// defaultValue={"All" || role}
									onChange={handleChange}
								>
									<MenuItem value="Select Business Nature" selected="SelectAll">
										Select Business Nature
									</MenuItem>
									{getBusinessNature.success &&
										getBusinessNature.data.roleList &&
										[]
											.concat(getBusinessNature.data.roleList)
											.map((dropdown) => (
												<MenuItem value={dropdown.role}>{dropdown.role}</MenuItem>
											))}
									{/* {getBusinessNature.success &&
                  getBusinessNature.data.roleList.map((dropdown) => (
                    <MenuItem value={dropdown.role}>{dropdown.role}</MenuItem>))} */}
								</TextField>
							</Grid>

							<DialogActions style={{ padding: "14px" }}>
								<Button
									style={{
										backgroundColor: "#fff",
										color: "#000"
									}}
									variant="contained"
									onClick={handleClose}
								>
									Cancel
								</Button>
								<Button
									style={{
										marginLeft: "0.7rem",
										backgroundColor: "#00b9f5",
										color: "white",
										// marginTop: "9px"
									}}
									variant="contained"
									onClick={CreateBusinessNatureMappingReq}
								>
									Create
								</Button>

							</DialogActions>
						</DialogContent>
					</Dialog>
				</div>

				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
						<DialogActions className="p-3">
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={deleteIntegration}
							>
								Yes
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				{/* </Card> */}

				{/* {logoutvalue ? <CommonLogout /> : ""} */}
			</Layout>

			{createBusinessNatureMappingResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createBusinessNatureMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createBusinessNatureMappingResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createBusinessNatureMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createBusinessNatureMappingResArray.status == "INVALID REQUEST" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createBusinessNatureMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteIntegrationArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteIntegrationArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteIntegrationArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteIntegrationArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteIntegrationArray.status == "INVALID REQUEST" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteIntegrationArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminAddNewBusinessNature;
